module.exports = __webpack_public_path__ + "static/img/693ad816f18d454b89d8c8c5d10bf4e6.bec04f20.png";